module.exports = __webpack_public_path__ + "static/img/profile-icon09.d45aae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon09.png
// module id = 2957
// module chunks = 1